<template>
  <div>
    <div
      style="display: none"
      class="top-header-mobile p-2 d-flex align-items-center justify-content-between"
    >
      <div class="logoTop-mob">
        <img src="../../../../static/fxView/images/logo.png" />
      </div>
      <div class="mobTop-menu">
        <div class="navbar-light">
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
      </div>
    </div>
    <div
      class="top-sidebar-header d-flex align-items-center justify-content-between border-bottom py-0 mb-3"
    >
      <div class="d-flex align-items-center">
        <h4>{{ nameFunction(pageName) }}</h4>
      </div>
      <!----------msz panel------------->
      <!--<p v-if="msz != ''" class="mszFade" :class="(msz_type == 'success')? 'alert alert-success' : 'error'">
            {{message}}
            <feather type="x"  v-if="message != ''" @click="message = ''"></feather>
        </p>-->
      <!-------------------------------->
      <div class="rightHeader-flow d-flex align-items-center">
        <div class="d-flex align-items-center mr-3">
          <router-link :to="'/notification-list'">
            <h4 class="position-relative">
              <feather type="bell"></feather>
              <sup
                class="supFile"
                v-if="
                  notificationUnreadList != '' &&
                  notificationUnreadList.totalRecords > 0
                "
                >{{ notificationUnreadList.totalRecords }}</sup
              >
            </h4>
          </router-link>
        </div>

        <div class="dropdown headerNot-mob border-left">
          <button
            class="btn dropdown-toggle pr-5"
            id="menu1"
            type="button"
            data-toggle="dropdown"
          >
            <div class="user-header d-flex align-items-center">
              {{ get_user.username.charAt(0) }}
            </div>
            <span class="caret"></span>
          </button>
          <ul
            class="dropdown-menu user p-0"
            role="menu"
            aria-labelledby="menu1"
          >
            <li role="presentation">
              <router-link :to="'/email-setting-list'"
                >Email Setting</router-link
              >
            </li>
            <!-- <li role="presentation"><router-link :to="'/notification-list'" >Notification</router-link></li> -->
            <!--  <li role="presentation"><router-link :to="'/notification-list-old'" >Notification</router-link></li> -->
            <li role="presentation">
              <router-link :to="'/change-password'"
                >Change Password</router-link
              >
            </li>

            <li role="presentation" class="divider"></li>
            <li role="presentation">
              <a role="menuitem" tabindex="-1" href="#" @click="logout()"
                >Logout</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fxViewMixins } from "@/plugins/fxView";
import * as types from "@/types";
import { mapActions } from "vuex";
import * as firebase from "firebase/app";
import "firebase/messaging";
export default {
  data() {
    return { message: "" };
  },
  mixins: [fxViewMixins],
  props: ["pageName"],
  computed: {
    /*fdeOut(){
                console.log(this.msz)
                this.message = this.msz
                if(this.message != ''){
                    setTimeout(function(){$('.mszFade').fadeOut();}, 6000);
                }
            }*/
  },
  created() {
    this.intializeFirebase();
  },
  methods: {
    nameFunction(getData) {
      let nameString = "";
      let name_array = getData.split("-");
      for (let i = 0; i <= name_array.length - 1; i++) {
        nameString = nameString + " " + name_array[i];

        if (i == name_array.length - 1) {
          return nameString;
        }
      }
    },
    ...mapActions({
      _runLogout: types.RUN_USER_LOGOUT,
      _runSaveuserToken: types.SAVE_FIREBASE_TOKEN,
    }),
    logout() {
      const r = this.$router;
      this._runLogout({
        router: r,
        parameter: this,
      });
    },
    redirec() {
      alert("Notification Page should come here");
    },
    saveFirebaseNotification(token) {
      // _runSaveuserToken
      const _that = this;
      let input_json = {
        globalParams: {
          firebaseToken: token,
        },
        localParams: {
          parameter: _that,
        },
      };
      _that._runSaveuserToken(input_json);
    },
    intializeFirebase() {
      const _that = this;
      const firebaseConfig = {
        apiKey: "AIzaSyCmsD-2IT6CCFUyj_fSGnaqhANqVk8naic",
        authDomain: "fxview-d860f.firebaseapp.com",
        databaseURL: "https://fxview-d860f.firebaseio.com",
        projectId: "fxview-d860f",
        storageBucket: "fxview-d860f.appspot.com",
        messagingSenderId: "462578346086",
        appId: "1:462578346086:web:8e33088eca7ff2cbfbe5a7",
      };
      firebase.initializeApp(firebaseConfig);
      navigator.serviceWorker
        .register("/static/firebase-messaging-sw.js")
        .then(function (registration) {
          const messaging = firebase.messaging();
          messaging.usePublicVapidKey(
            "BCJRn_O4j3bPnNuhkqyPy7uDwXkMiT6wOl4rYZV8xX9wxGZeVrLLjNUrc3YnPIWi2gW0plEqzdicmWnSsMTBg3o"
          );
          messaging.useServiceWorker(registration);

          messaging
            .getToken()
            .then((currentToken) => {
              if (currentToken) {
                // console.log("Current Push notification token", currentToken)
                //sendTokenToServer(currentToken);
                //updateUIForPushEnabled(currentToken);
                _that.saveFirebaseNotification(currentToken);
              } else {
                // Show permission request.
                // console.log('No Instance ID token available. Request permission to generate one.');
                // Show permission UI.
                // updateUIForPushPermissionRequired();
                // setTokenSentToServer(false);
              }
            })
            .catch((err) => {
              // _that.reaskPermission()
              // console.log('An error occurred while retrieving token. ', err);
              // showToken('Error retrieving Instance ID token. ', err);
              // setTokenSentToServer(false);
            });

          messaging.onMessage((payload) => {
            _that.$notify({
              group: "foo",
              type: "warn",
              title: "User Facing issue in uploading document",
              text: payload.data.title,
              duration: 10000,
              closeOnClick: _that.redirect(),
            });
            // _that.newUpdate = true;
          });

          messaging.onTokenRefresh(function () {
            messaging
              .getToken()
              .then(function (newToken) {
                _that.saveFirebaseNotification(newToken);
                // this.saveNotificationToken(newToken)
              })
              .catch(function (err) {
                console.log("Unable to retrieve refreshed token ", err);
              });
          });
        })
        .catch(function (err) {
          console.error("Service Worker registration failed", err);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/header.vue